import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import modalStyles from '~styles/modalStyles.scss';
import { showServerErrorMsg } from '~actions/errorActions';

const ErrorMessageModal = props => {
  if (props.showServerErrorMsg) {
    setTimeout(() => props.showServerErrorMsg(false), 10000);
  }
  return (
    <Modal
      size="large"
      show={props.errorMsgVisible}
      dialogClassName={modalStyles.errorModal}
      onHide={() => props.showServerErrorMsg(false)}
    >
      <Modal.Body>
        <p className={modalStyles.askede}>
          Virhe palvelussa. Päivitä selain tai yritä myöhemmin uudelleen.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default connect(
  state => ({
    errorMsgVisible: state.errorReducer.errorMsgVisible,
  }),
  { showServerErrorMsg }
)(ErrorMessageModal);
